import styled, { css, keyframes } from 'styled-components';
import Theme from '../../design-system/Theme';
import getSubjectsType from '../../utils/get-Subject-Types';

const newTheme = new Theme();
const { mobile, tablet } = newTheme.breakpoints;

type PropTypesColor = {
  $subject: string,
  $color: number,
  $aulaname?: string,
}

type PropTypesBox = {
  sidebar: boolean,
}

export const Container = styled.article`
  position: relative;  
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-radius: 20px;
  width: 1000px;
  flex-shrink: 0; 
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  background: ${({ theme }) => theme.colors.grayscale[110]};
  overflow-x: hidden;

  .active ~ & {
    transform: translateX(-300px);
  }
`;

export const ContentTitle = styled.section<PropTypesColor>`
  width: 100%;
  border-radius: 20px 20px 0px 0px;
  background: #A648FF;  
  color: #FFFFFF;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 48px;
  max-height: 120px;
  flex-wrap: wrap;

  .breadcrumb__item ~ .breadcrumb__parent, .breadcrumb__subitem {
    display: none;
  }

  .breadcrumb__parent {
    font-family: 'Museo', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: 34px;
  }

  .breadcrumb__item, .breadcrumb__subitem {
    color: #FFFFFF;
    font-family: 'Museo', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: 34px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 12px 0 12px 24px;
  }
`;

export const BoxArtigo = styled.section<PropTypesColor>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grayscale[110]};

  p {
    ${({ theme }) => theme.typography.normal}

    .realceAmarelo { background-color: #fffcc1; color: black; }
    .realceAzul { background-color: #cbf0fe; color: black; }
    .realceRosa { background-color: #ffdbf7; color: black; }
    .realceTurquesa { background-color: #ccffff; color: black; }
    .realceVerde { background-color: #e2ffca; color: black; }
    .realceVermelho { background-color: #ffd8d8; color: black; }
    .textoColorido { color: #0014a9; }
    .numeroRodape { 
      background-color: #ffe0dc;
      border: 0;
      border-bottom: 3px solid #ff9f9f;
      border-radius: 4px;
      color: #333;
      cursor: pointer;
      font-size: 20px;
      font-feature-settings: 'sups' on;
      font-weight: 600;
      padding: 0 8px;
     }

     .termoGlossario { 
       ${({ theme }) => theme.typography.normal}
      background-color: #ffe0dc;
      border: 0;
      border-bottom: 3px solid #ff9f9f;
      border-radius: 4px;
      color: #333;
      cursor: pointer;
      padding: 0 8px;
      font-weight: 600;
     }

    .destaqueCaixaAlta { text-transform: uppercase; }
    .italico { font-style: italic; }
    .negrito { font-weight: bold; }
    .listaAlfabetica { list-style-type: lower-greek; }
    .listaBullets { list-style-type: disc; }
    .listaNumerica { list-style-type: decimal; }
    .listaRomana { list-style-type: upper-roman; }
    .sublinhado { text-decoration: underline; }

    &.referencia {
      font-size: 1rem;
      margin-bottom: 8px;
    }
  }

  ${({ $aulaname }) => (Number($aulaname) === 0
    ? css<PropTypesColor>`
      table {
    max-width: 99%;
    @media (min-width: ${mobile}) {
      margin-top: 280px;
    }
    @media screen and ((min-width: calc(${mobile} + 1px)) and (max-width: ${tablet})) {
      margin-top: 100px;
    }
    @media screen and (min-width: calc(${tablet} + 1px)) {
      margin-top: 100px;
    }

    li {
      ${({ theme }) => theme.typography.normal}
    }

    p {
      ${({ theme }) => theme.typography.h3}
    }

    tr {
      display: flex;
      flex-direction: column;
      border-spacing: 1em;
      margin-bottom: 30px;

      ul {
        padding-left: 14px;
      }

      ul li::marker {
        color: ${({ theme, $color, $subject }) => getSubjectsType({ theme, color: $color, subject: $subject })};
      }

      &:first-child {
        ul {
          list-style-type: none;
          padding-left: 0px;
        }
      }

      &:nth-child(2) {
        ul {
          list-style-type: disc ;
        }
      }

      &:nth-child(3) {
        ul {
          list-style-type: none;
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
      }

      td {
        &:first-child {
          p {
            border-bottom: 4px solid ${({ theme, $color, $subject }) => getSubjectsType({ theme, color: $color, subject: $subject })};
          }
        }

        &:last-child {
          margin-top: 20px;
          padding-left: 30px;
        }
      }
    }
  }
    `
    : css``
  )}

  img {
    max-width: 100%;
  }
  
  .boxSimples {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 8px 0;
  }
`;

const slideIn = keyframes`
  from { left: 50px; }
  to { left: 150px; }
`;

const slideOut = keyframes`
  from { left: 100px; }
  to { left: 0; }
`;

export const Box = styled.div<{ $sidebar: boolean }>`
  max-height: 100%;
  width: 1000px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  overflow-y: auto;
  position: relative;

  @media (min-width: 1440px) {
    animation: ${({ $sidebar }) => ($sidebar ? slideIn : slideOut)} 300ms forwards;
  }

  @media (max-width: 600px){
    ${({ $sidebar }) => ($sidebar && 'max-height: 100vh;')}

  }
  @media (max-width: 1440px){
    margin-top: 3.5rem;
  }
`;

export const TitleContainer = styled.div`
  *:last-child {
    margin: 0;
  }
`;

export const BorderContainer = styled.div`
  margin-top: 18px;  

  svg {
    width: 100%;
    height: 4px;
  }
`;
